import { render, staticRenderFns } from "./ManageCerts.vue?vue&type=template&id=07e59cd0&"
import script from "./ManageCerts.vue?vue&type=script&lang=js&"
export * from "./ManageCerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports